import { DatePipe } from "@angular/common";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'environment/environment';
import { Observable, catchError, throwError } from "rxjs";
import { Mydetaildata, Mydetaillist, mydetail, GlobalSearch, meterread, openingbalance } from "./mydetail.model";
import moment from "moment";
import { esigndetail } from "../auth/esign/esign.model";



@Injectable({
    providedIn: 'root'
})
export class mydetailService {
    private apiUrl: string;
    private createdby: number;
    datePipe: DatePipe = new DatePipe('en-US');
    esigndetails: esigndetail = new esigndetail();

    constructor(private _httpClient: HttpClient) {
        this.apiUrl = environment.baseUrl;
        this.createdby = environment.createdby;
    }
    getAll(custid: number): Observable<any> {
        ;

        let params = new HttpParams();


        return this._httpClient.get<Mydetaillist[]>(this.apiUrl + 'Mydetail/mydetail/' + custid, {
            observe: 'body',
            params,
        });
    }
    GetConfigDatabyName(name: string): Observable<any> {

        let params = new HttpParams();
        params = params.append('name', name);
        return this._httpClient.get<any[]>(this.apiUrl + 'config/GetConfigDatabyName/'+name, {
            observe: 'body',
            params,
        });
    }
    SaveUpdateDeletemydetail(Mydetaillist: Mydetaildata): Observable<any> {

        var date = new Date();
        var transformDate = this.datePipe.transform(date, 'yyyy-MM-dd');



        Mydetaillist.createdBy = this.createdby;



        return this._httpClient.post<mydetail>(this.apiUrl + 'Mydetail/Updatemydetail', Mydetaillist).pipe(catchError(this.handleError));;
    }

    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    globalsearch(GlobalSearch: any): Observable<any> {


        let params = new HttpParams();

        params = params.append('quoteId', GlobalSearch.coreSPID);
        params = params.append('quoteId', GlobalSearch.pageSize);
        params = params.append('quoteId', GlobalSearch.pageNo);
        params = params.append('quoteId', GlobalSearch.customerID);
        params = params.append('email', GlobalSearch.customerType);
        params = params.append('businessName', GlobalSearch.search);
        params = params.append('businessName', GlobalSearch.sewerageSPID);
        params = params.append('businessName', GlobalSearch.waterSPID);

        return this._httpClient.get<GlobalSearch[]>(this.apiUrl + 'Quotation/SendEmailEsign', {
            observe: 'body',
            params,
        });
    }
    getCustomerMSNList(cust_id: String): Observable<any> {

        //console.log("test log : getUserById API Call", quote_id);
        return this._httpClient.get<any[]>(this.apiUrl + 'Mydetail/getCustomerMSNList/' + cust_id);

    }
    SaveUpdateDeletemeterread(cls: meterread, user_id: number, cust_Id: number, imagefile: File): Observable<any> {
        debugger;

        cls.cust_id = cust_Id;
        cls.created_id = user_id;
        cls.meter_read_mode = "Internal"
        cls.fileUpload = imagefile;
        cls.meter_read_date = moment(cls.meter_read_date).format("DD/MM/YYYY")
        console.log("cls", cls);
        const formData = new FormData();
        Object.keys(cls).forEach((key) => {

            formData.append(key, cls[key]);
        });

        return this._httpClient.post<any>(this.apiUrl + 'Mydetail/AddInsertUpdateMeterRead', formData).pipe(catchError(this.handleError));;
    }

    getlist(search: string, rowsPerPage: number, page: number, cust_Id: number, meter_read_id: any): Observable<any> {

        //console.log("test log : getUserById API Call", quote_id);
        let params = new HttpParams();
        if (search && search !== undefined)
            params = params.append('SearchText', search);


        params = params.append('cust_id', cust_Id);
        params = params.append('meter_read_id', meter_read_id);
        params = params.append('PageNo', page);
        params = params.append('PageSize', rowsPerPage);
        return this._httpClient.get<any[]>(this.apiUrl + 'Mydetail/Getmeterreaddata', {
            observe: 'body',
            params,
        });
    }
    DeleteData(clsdelete: meterread): Observable<any> {


        clsdelete.Type = "Delete";
        //    clsdelete.initial_reading_indicator = "1"
        //    clsdelete.deemed_reading_indicator = "1"
        // if (clsdelete.initial_reading_indicator == "Y") {
        //     clsdelete.initial_reading_indicator = "1"
        // }
        // else (
        //     clsdelete.initial_reading_indicator = "0"
        // )
        // if (clsdelete.deemed_reading_indicator == "Y") {
        //     clsdelete.deemed_reading_indicator = "1"
        // }
        // else (
        //     clsdelete.deemed_reading_indicator = "0"
        // )
        const formData = new FormData();

        Object.keys(clsdelete).forEach((key) => {

            formData.append(key, clsdelete[key]);
        });

        return this._httpClient.post<any>(this.apiUrl + 'Mydetail/AddInsertUpdateMeterRead', formData).pipe(catchError(this.handleError));;
    }




    updatecustomer(cust_Id: Number,  billing_rm_Paf_Id: Number, site_rm_Paf_Id: Number, userid: Number, site_reference_id: string, EmailId: string, PhoneNo: string,  bill_address_id: Number, site_address_id: Number,Note:string='',mobileNo: string): Observable<any> {
        debugger;
        // var date = new Date();
        // var transformDate = this.datePipe.transform(date, 'yyyy-MM-dd');
        this.esigndetails.siteaddress_id = Number(site_address_id);
        this.esigndetails.address_id = Number(bill_address_id);
        this.esigndetails.site_rm_Paf_Id = site_rm_Paf_Id;
        this.esigndetails.billing_rm_Paf_Id = billing_rm_Paf_Id;
        this.esigndetails.PhoneNo = String(PhoneNo);
        this.esigndetails.MobileNo = String(mobileNo);

        this.esigndetails.UserId = Number(userid);
        this.esigndetails.cust_id = Number(cust_Id);
        this.esigndetails.site_reference_id = site_reference_id;
        this.esigndetails.EmailId = EmailId;
        this.esigndetails.notes = Note;

        return this._httpClient.post<mydetail>(this.apiUrl + 'Mydetail/customeraddress', this.esigndetails).pipe(catchError(this.handleError));;
    }



    getmetercommentsDropDownList(): Observable<any> {

        return this._httpClient.get<any>(this.apiUrl + 'Mydetail/GetMeterCommentsList');
    }



    InsertUpdateOpeningBalance(clsopeningbalance: openingbalance): Observable<any> {

        return this._httpClient.post<any>(this.apiUrl + 'Mydetail/InsertUpdateOpeningBalance', clsopeningbalance).pipe(catchError(this.handleError));;
    }

    get_meter_read_type(type: String): Observable<any> {

        //console.log("test log : getUserById API Call", quote_id);
        return this._httpClient.get<any[]>(this.apiUrl + 'Mydetail/meteringlist/' + type);

    }

    get_meter_read_method(type: String): Observable<any> {

        //console.log("test log : getUserById API Call", quote_id);
        return this._httpClient.get<any[]>(this.apiUrl + 'Mydetail/meteringlist/' + type);

    }
    downloadimg(meter_read_id: number): Observable<any> {

        return this._httpClient.get(this.apiUrl + 'Mydetail/downloadimage/' + meter_read_id, {
            responseType: 'blob'
        });
    }
}
